export { ExcursionContent } from "./excursion-content";
